var Layer = require("./Layer"),
    $     = require("jquery"),
    _     = require("underscore");

var legendTypes = {
    1:'thematic',
    2:'category',
    3:'bubble',
    4:'PieChart',
    5:'BarChart',
    6:'LineChart',
    7:'heat'
};

var Visualization = Layer.extend({

    initialize: function () {
        var that     = this;
        that._legend = false;
        Visualization.__super__.initialize.apply(that, arguments);
    },

    /**
     * Загружает информацию легенды визуализации
     *
     * @method getLegend
     * @return {jQuery.Promise}
     */
    getLegend: function () {
        var that = this;

        return $.when()
            .then(function () {
                if (!that._legend) {
                    return that.project.loadLegend(that.get('code'))
                        .then(function (legend) {
                            if(_.isEmpty(legend)){
                                return $.Deferred().reject();
                            }
                            legend['type'] = legendTypes[legend['type']];
                            that._legend = legend;
                            return that._legend;
                        })
                }

                return that._legend;
            });
    }
});

module.exports = Visualization;


//////////////////
// WEBPACK FOOTER
// ./src/Project/Visualization.js
// module id = 15
// module chunks = 0